// NOTE: this component should NOT be used for new UIs

import React, {Component} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import {brand, greys} from "@irati/ui/src/global/colors"
import {RouterLink} from "../Link"
import Card from "./Card"
import Icon from "../Icon"
import isColorLight from "../global/isColorLight"
import media from "../global/media"

const CardWrapper = styled.div`
  position: relative;
`

const CardWithShadow = styled(Card)`
  box-shadow: 0 2px 1px 2px rgba(61,61,54,0.17);
  margin-left: 15px;
  margin-right: ${(props) => (props.bothSides ? "15px" : "0")};
  overflow: visible;
  ${media.tablet`
    margin: 0;
  `}
`

const LayeredCard = styled(Card)`
  height: 100%;
  left: 0;
  position: absolute;
  right: ${(props) => (props.bothSides ? "0" : "15px")};
  top: 15px;
  ${media.tablet`
    margin: 0;
  `}
`

const StyledLinkWrapper = styled.div`
  left: -15px;
  position: absolute;
`

const StyledIconWrapper = styled.div`
  background-color: ${() => brand.shade};
  border-radius: 6px 0 0 6px;
  padding: 15px 2px;
`

const StyledIcon = styled(Icon)`
  font-size: 25px;
`

class ShadowCard extends Component {
  static propTypes = {
    bothSides: PropTypes.bool,
    children: PropTypes.node,
    linkProps: PropTypes.shape({
      app: PropTypes.object,
      onClick: PropTypes.func,
      to: PropTypes.string
    })
  }

  static defaultProps = {
    bothSides: false,
    children: null,
    linkProps: null
  }

  render() {
    const {bothSides, children, linkProps, ...other} = this.props

    return (
      <CardWrapper>
        <LayeredCard bothSides={bothSides} />
        <CardWrapper>
          <CardWithShadow {...other}>
            {linkProps &&
              <StyledLinkWrapper>
                <RouterLink {...linkProps}>
                  <StyledIconWrapper>
                    <StyledIcon
                      color={isColorLight(brand.shade) ? greys.black : greys.white}
                      icon="backArrow" />
                  </StyledIconWrapper>
                </RouterLink>
              </StyledLinkWrapper>
            }
            {children}
          </CardWithShadow>
        </CardWrapper>
      </CardWrapper>
    )
  }
}

export default ShadowCard
